var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3783 15.8124C23.7879 14.59 24 13.303 24 12C24 10.4241 23.6896 8.8637 23.0865 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40041 18.0481 1.5165 16.5922 0.913445C15.1363 0.310389 13.5759 0 12 0C9.62662 0 7.30655 0.703787 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.91345 7.4078C0.00519937 9.60051 -0.23244 12.0133 0.230582 14.3411C0.693604 16.6688 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.7138 24.1781 13.8349 24.0409 15.8124 23.3783C15.2972 22.541 15 21.5552 15 20.5C15 17.4624 17.4624 15 20.5 15C21.5552 15 22.541 15.2972 23.3783 15.8124Z",
    fill: "#FFC7DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18656 17.2518C8.47385 17.5236 5.65286 16.98 5.90811 14.0529C5.90811 14.0529 3.81639 12.8761 4.01529 11.0463C4.21418 9.21644 5.61639 8.92804 6.04733 9.03412C6.04733 9.03412 5.03297 6.0507 7.10811 4.93689C9.18324 3.82307 10.3169 4.60539 11.3214 5.50042C11.3214 5.50042 11.7921 3.37556 13.8606 3.63412C15.9291 3.89269 16.2573 6.02749 16.2573 6.02749C16.2573 6.02749 18.8064 5.58992 19.4164 7.46617C19.6039 7.96172 19.6295 8.50395 19.4895 9.01497C19.3496 9.52599 19.0512 9.9795 18.6374 10.3104C18.6374 10.3104 20.096 11.9181 17.9181 13.012L16.6617 8.63965C16.6617 8.63965 13.3037 11.0098 11.096 10.1977C11.096 10.1977 11.0197 13.8441 9.21308 13.8441L9.18656 17.2518Z",
    fill: "#002955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2586 12.9352C10.2586 12.9352 8.10061 10.0286 7.27941 11.1362C5.95403 12.9085 10.3694 14.9558 10.3694 14.9558L10.2586 12.9352Z",
    fill: "#0070E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1495 18.2469C12.8366 18.3031 12.5138 18.2594 12.227 18.122C11.9403 17.9845 11.704 17.7603 11.5518 17.4812C11.5518 17.4546 11.6446 17.3983 11.6578 17.4149C12.1216 17.7186 12.6261 17.9552 13.1562 18.1176C13.1794 18.1176 13.1562 18.2436 13.1562 18.2469",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0153 20.913C14.5284 20.831 13.9899 20.766 13.3946 20.7246H9.24437C9.24437 20.7246 5.26647 20.9235 4.19907 23.9268C3.44334 26.0532 11.3251 24.6518 15.9923 23.6521C15.441 22.8653 15.0906 21.9274 15.0153 20.913Z",
    fill: "#FF727F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1376 15.5318C18.2275 12.5016 16.3857 7.6377 16.3857 7.6377V7.64764C14.5094 7.00123 9.42105 7.6377 9.29508 9.74267C9.06635 13.6211 9.24536 20.725 9.24536 20.725H13.3956L13.1934 18.1592C13.1934 18.1592 14.2625 18.3173 15.5194 18.1637C16.0606 17.0121 16.9893 16.0788 18.1376 15.5318Z",
    fill: "#0070E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18656 17.2518C8.47385 17.5236 5.65286 16.98 5.90811 14.0529C5.90811 14.0529 3.81639 12.8761 4.01529 11.0463C4.21418 9.21644 5.61639 8.92804 6.04733 9.03412C6.04733 9.03412 5.03297 6.0507 7.10811 4.93689C9.18324 3.82307 10.3169 4.60539 11.3214 5.50042C11.3214 5.50042 11.7921 3.37556 13.8606 3.63412C15.9291 3.89269 16.2573 6.02749 16.2573 6.02749C16.2573 6.02749 18.8064 5.58992 19.4164 7.46617C19.6039 7.96172 19.6295 8.50395 19.4895 9.01497C19.3496 9.52599 19.0512 9.9795 18.6374 10.3104C18.6374 10.3104 20.096 11.9181 17.9181 13.012L16.6617 8.63965C16.6617 8.63965 13.3037 11.0098 11.096 10.1977C11.096 10.1977 11.0197 13.8441 9.21308 13.8441L9.18656 17.2518Z",
    fill: "#002955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2586 12.9352C10.2586 12.9352 8.10061 10.0286 7.27941 11.1362C5.95403 12.9085 10.3694 14.9558 10.3694 14.9558L10.2586 12.9352Z",
    fill: "#0070E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1495 18.2469C12.8366 18.3031 12.5138 18.2594 12.227 18.122C11.9403 17.9845 11.704 17.7603 11.5518 17.4812C11.5518 17.4546 11.6446 17.3983 11.6578 17.4149C12.1216 17.7186 12.6261 17.9552 13.1562 18.1176C13.1794 18.1176 13.1562 18.2436 13.1562 18.2469",
    fill: "#202020"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3125 19.9375H21.0625V17.6875C21.0625 17.3781 20.8094 17.125 20.5 17.125C20.1906 17.125 19.9375 17.3781 19.9375 17.6875V19.9375H17.6875C17.3781 19.9375 17.125 20.1906 17.125 20.5C17.125 20.8094 17.3781 21.0625 17.6875 21.0625H19.9375V23.3125C19.9375 23.6219 20.1906 23.875 20.5 23.875C20.8094 23.875 21.0625 23.6219 21.0625 23.3125V21.0625H23.3125C23.6219 21.0625 23.875 20.8094 23.875 20.5C23.875 20.1906 23.6219 19.9375 23.3125 19.9375Z",
    fill: "#25E8C8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7C3.5 4.8125 2.04717 3.5 0 3.5C2.04717 3.5 3.5 2.1875 3.5 2.38419e-07C3.5 2.1875 4.95283 3.5 7 3.5C4.98585 3.5 3.5 4.8125 3.5 7Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 2,
    r: 1,
    fill: "#9287FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -3,
    y: -2,
    width: 13,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.ef74a9ab.svg";
export { ForwardRef as ReactComponent };